import { KV } from "../report/sections/util";
interface Element {
  color: string;
  name: string;
  data?: any;
}
export const ColorBox = ({ color }: { color: string }) => (
  <span className="color-box mr-2 float-left" style={{ border: "8px solid " + color }} />
);
interface ColorBoxLabelProps {
  elem: Element;
  children?: React.ReactNode;
}
export const ColorBoxLabel = ({ elem, children = undefined }: ColorBoxLabelProps) =>
  !elem ? null : (
    <div>
      <ColorBox color={elem.color} /> {elem.name} {children}
    </div>
  );
interface KVColorBoxLabelProps {
  k: string;
  elem: Element;
  DataComponent?: React.ComponentType<{ data: any }>;
}
export const KVColorBoxLabel = ({ k, elem, DataComponent = undefined }: KVColorBoxLabelProps) =>
  !elem ? null : (
    <KV k={k}>
      <ColorBoxLabel elem={elem}>
        {!(DataComponent && elem.data) ? null : <DataComponent data={elem.data} />}
      </ColorBoxLabel>
    </KV>
  );

function datasWrapper(func) {
  return ({ elem, ...props }) => {
    if (!elem?.[0]) return null;
    return func({ ...props, elem: elem.reduce((a, b) => (a.overlap > b.overlap ? a : b)) });
  };
}
export const DColorBoxLabel = datasWrapper(ColorBoxLabel);
export const DKVColorBoxLabel = datasWrapper(KVColorBoxLabel);
